// extracted by mini-css-extract-plugin
export default {"sidebar":"SideBar_sidebar__ygxkJ","Closesidebar":"SideBar_Closesidebar__48TcY","Opensidebar":"SideBar_Opensidebar__Hqy+q"};